module.exports = __webpack_public_path__ + "static/media/cheese.eb8838e7.svg";